import { RESOLUTION_SETTINGS } from 'src/config';
import { ExportResolution } from 'src/types';

interface ResolutionSelectorProps {
  selectedResolution: ExportResolution;
  onSelect: (resolution: ExportResolution) => void;
  testId?: string;
}

export function ResolutionSelector({
  selectedResolution,
  onSelect,
  testId = 'export-resolution-select',
}: ResolutionSelectorProps) {
  return (
    <div className="w-full">
      <label
        htmlFor={testId}
        className="mb-2 block text-sm font-medium text-gray-700"
      >
        Resolution
      </label>
      <select
        id={testId}
        name="resolution"
        value={selectedResolution}
        onChange={(e) => onSelect(e.target.value as ExportResolution)}
        data-testid={testId}
        className="mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500"
      >
        {Object.entries(RESOLUTION_SETTINGS).map(([key, value]) => (
          <option key={key} value={key}>
            {value.label}
          </option>
        ))}
      </select>
      <p className="mt-1 text-xs text-gray-500">
        Higher resolution = better quality but larger file size
      </p>
    </div>
  );
}
